import {Component, EventEmitter, Output, Input, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {ThemeConstantService} from '../../services/theme-constant.service';
import {Router} from '@angular/router';
import {AuthService} from '../../services/authentication.service';
import {environment} from '../../../../environments/environment';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})

export class FooterComponent implements OnInit {
  date = new Date();
  isLoggedInUser = false;


  constructor(
    public translate: TranslateService,
    private router: Router, private authService: AuthService
  ) {

  }

  ngOnInit(): void {
    this.authService.getAuthState().subscribe(user => {
      if (user && !user.isAnonymous) {
        this.isLoggedInUser = true;
      } else {
        this.isLoggedInUser = false;
      }
    });
  }

  navigateToAcademy() {
    if (this.isLoggedInUser) {
      this.authService.redirectToConsole(`${environment.consoleURL}/mtsacademy/onboarding-program`, {});
    } else {
      this.router.navigate(['/auth/login']);
    }
  }

}
